/**
 * Helpers for column order changes. HTML5 drag-and-drop is unreliable on
 * touch browsers; mobile UIs use adjacent swaps via these functions.
 */

/** Ads Manager: reorder among visible (non-hidden) columns only. */
export function reorderVisibleColumnPair(
  columnOrder: string[],
  hiddenColumns: Set<string>,
  fromVisibleIdx: number,
  toVisibleIdx: number,
): string[] {
  const visibleOrder = columnOrder.filter((id) => !hiddenColumns.has(id))
  if (
    fromVisibleIdx < 0 ||
    toVisibleIdx < 0 ||
    fromVisibleIdx >= visibleOrder.length ||
    toVisibleIdx >= visibleOrder.length
  ) {
    return columnOrder
  }
  const fromId = visibleOrder[fromVisibleIdx]
  const toId = visibleOrder[toVisibleIdx]
  const newOrder = [...columnOrder]
  const fromFull = newOrder.indexOf(fromId)
  const toFull = newOrder.indexOf(toId)
  if (fromFull === -1 || toFull === -1) return columnOrder
  newOrder.splice(fromFull, 1)
  newOrder.splice(toFull, 0, fromId)
  return newOrder
}

/** Dashboard tables: move one column one step; pinned column must stay first. */
export function moveColumnAdjacent(
  columnOrder: string[],
  columnId: string,
  direction: -1 | 1,
  pinnedColumnId: string,
): string[] | null {
  const i = columnOrder.indexOf(columnId)
  if (i < 0) return null
  const j = i + direction
  if (j < 1) return null
  if (j >= columnOrder.length) return null
  const next = [...columnOrder]
  ;[next[i], next[j]] = [next[j], next[i]]
  if (next[0] !== pinnedColumnId) {
    const p = next.indexOf(pinnedColumnId)
    if (p > 0) {
      next.splice(p, 1)
      next.unshift(pinnedColumnId)
    }
  }
  return next
}
